import { useEffect } from 'react';

// this is necessary for gatsby to build using the window object
const isBrowser = typeof window !== 'undefined';

function useKeypress(key: string, action: (e: any) => void) {
  useEffect(() => {
    function onKeyup(e: KeyboardEvent) {
      if (e.key === key) action(e);
    }
    isBrowser && window.addEventListener('keyup', onKeyup);
    return () => {
      isBrowser && window.removeEventListener('keyup', onKeyup);
    };
  }, [action, key]);
}

export default useKeypress;
